module.exports = __webpack_public_path__ + "static/media/zoom.b0d30cdd.svg";